module.exports = __webpack_public_path__ + "static/media/038.7e24fa1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/038.jpg
// module id = 384
// module chunks = 0